"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoachMarkAnchor = exports.CoachMarkActions = exports.CoachMark = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const Detail_1 = require("./Detail");
require("./CoachMark.pc.css");
const CoachMark = ({ className, centered, steps, title, description, actions, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_cf670c53', '_e382482e', '_pub-e382482e', '_pub-3c25d522', {
            '_e382482e_centered _pub-e382482e_centered _pub-3c25d522_centered centered': centered,
        }, className) },
        steps,
        react_1.default.createElement(Detail_1.Detail, { className: (0, clsx_1.default)('_3104944b', '_e382482e', '_pub-e382482e', '_pub-3c25d522'), title: title, description: description }),
        actions));
};
exports.CoachMark = CoachMark;
const CoachMarkActions = ({ className, actions, end, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_28df2154', '_e382482e', '_pub-e382482e', '_pub-3c25d522', { '_e382482e_end _pub-e382482e_end _pub-3c25d522_end end': end }, className) }, actions));
};
exports.CoachMarkActions = CoachMarkActions;
const CoachMarkAnchor = ({ style, className, right, card, }) => {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('_272b2f73', '_e382482e', '_pub-e382482e', '_pub-3c25d522', {
            '_e382482e_right _pub-e382482e_right _pub-3c25d522_right right': right,
        }, className), style: style },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_6e729d7', '_e382482e', '_pub-e382482e', '_pub-3c25d522') },
            react_1.default.createElement("div", { className: (0, clsx_1.default)('_bce68579', '_e382482e', '_pub-e382482e', '_pub-3c25d522') })),
        react_1.default.createElement("div", { className: (0, clsx_1.default)('_71e01941', '_e382482e', '_pub-e382482e', '_pub-3c25d522') }, card)));
};
exports.CoachMarkAnchor = CoachMarkAnchor;
//# sourceMappingURL=CoachMark.js.map